import React from "react";

import Box from "@material-ui/core/Box";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

const LineChart = ({ title, xAxisTitle, yAxisTitle, data, height, width }) => {
  return (
    // <div style={{ height, width }}>
    <Box border={2} style={{ padding: "1em", width, height }}>
      <Line
        data={data}
        plugins={[ChartDataLabels]}
        options={{
          plugins: {
            legend: { display: true, position: "right" },
            datalabels: {
              display: false,
              color: "#fff",
            },
            title: {
              display: true,
              font: {
                size: 16,
              },
              text: title,
            },
          },
          responsive: true,
          scales: {
            yAxes: {
              title: {
                display: true,
                text: yAxisTitle,
                font: {
                  size: 18,
                },
              },
              ticks: {
                precision: 0,
              },
            },
            xAxes: {
              title: {
                display: true,
                text: xAxisTitle,
                font: {
                  size: 18,
                },
              },
            },
          },
        }}
      />
    </Box>
  );
};

export default LineChart;
